module.exports = __webpack_public_path__ + "img/xtnl-002.0a0ad02e.jpeg";